import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 5C11.1233 5 12.8908 6.45723 13.2875 8.39785C14.8042 8.49911 16 9.70251 16 11.1875C16 12.74 14.6933 14 13.0833 14H5.5C3.56917 14 2 12.4869 2 10.625C2 8.88689 3.36502 7.45287 5.12083 7.27285C5.85 5.92285 7.31417 5 9 5ZM9 6.575C7.74552 6.575 6.6929 7.38601 6.36315 8.49893L6.26654 8.825H5.5C4.46857 8.825 3.63333 9.6304 3.63333 10.625C3.63333 11.6196 4.46857 12.425 5.5 12.425H13.0833C13.7939 12.425 14.3667 11.8727 14.3667 11.1875C14.3667 10.5023 13.7939 9.95 13.0833 9.95H11.7417V9.21875C11.7417 7.75728 10.5156 6.575 9 6.575Z",
		fill: "black"
	})
});
export default SvgCloud;
